import React, { useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

const ViewResult = () => {
  const docs = [
    {
      uri: "https://calibre-ebook.com/downloads/demos/demo.docx",
      fileType: "docx",
      fileName: "demo.docx",
    },
  ];

  useEffect(() => {
    // Inject CSS to override the height of .fBdFME class
    const style = document.createElement("style");
    style.innerHTML = `
      .fBdFME {
        height: 500px !important; /* or whatever height you need */
        width: 100% !important;
      }
    `;
    document.head.appendChild(style);

    // Cleanup the style element on component unmount
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <MDTypography>Viewing result</MDTypography>
        <DocViewer
          documents={docs}
          pluginRenderers={DocViewerRenderers}
          // style={{ width: "100%" }}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default ViewResult;
